export default "__VITE_ASSET__ycKfKGAL__"